import React, { useState } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector: React.FC = () => {
    const { currentLanguage, languages, setLanguage, isLoading, t } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);



    if (isLoading || languages.length === 0) {
        return null;
    }

    const currentLang = languages.find(lang => lang.code === currentLanguage);

    const handleLanguageChange = (languageCode: string) => {
        setLanguage(languageCode);
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 rounded-lg hover:bg-gray-100 dark:hover:bg-secondary-800"
                aria-label={t('aria.selectLanguage')}
            >
                <Globe className="w-4 h-4" />
                <span className="hidden sm:inline">
                    {currentLang?.native_name || currentLang?.name || currentLanguage.toUpperCase()}
                </span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <>
                    {/* Backdrop */}
                    <div
                        className="fixed inset-0 z-10"
                        onClick={() => setIsOpen(false)}
                    />

                    {/* Dropdown */}
                    <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-secondary-800 rounded-lg shadow-lg border border-gray-200 dark:border-secondary-700 z-20">
                        <div className="py-1">
                            {languages
                                .filter(lang => lang.is_active)
                                .sort((a, b) => a.sort_order - b.sort_order)
                                .map((language) => (
                                    <button
                                        key={language.code}
                                        onClick={() => handleLanguageChange(language.code)}
                                        className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-secondary-700 transition-colors duration-200 ${currentLanguage === language.code
                                            ? 'text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/20'
                                            : 'text-gray-700 dark:text-gray-300'
                                            }`}
                                    >
                                        <div className="flex items-center justify-between">
                                            <span>{language.native_name}</span>
                                            {currentLanguage === language.code && (
                                                <div className="w-2 h-2 bg-primary-600 dark:text-primary-400 rounded-full" />
                                            )}
                                        </div>
                                        {language.native_name !== language.name && (
                                            <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                {language.name}
                                            </div>
                                        )}
                                    </button>
                                ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default LanguageSelector;
